<template>
  <div>
    <h3 class="headline">{{ $t('ระยะเวลา') }}</h3>
    <div>
      <div class="mb-2">ระยะเวลาสมัครโครงการ</div>
      <v-layout wrap class="form-control">
        <v-flex xs3 class="form-control" :class="{ 'has-error': errors.has('startdate') }">
          <v-menu
            ref="openStartDate"
            v-model="openStartDate"
            :close-on-content-click="false"
            full-width
            max-width="290px"
            color="primary"
          >
            <template v-slot:activator="{ on }">
              <input
                type="text"
                class="form-control browser-default"
                :placeholder="$t('Start Date')"
                readonly
                v-model="startDate"
                v-on="on"
                clearable
              />
            </template>
            <v-date-picker
              @change="onChangeDatetime"
              color="primary"
              v-model="startDate"
              @input="openStartDate = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs2 class="pl-1">
          <v-menu
            ref="startTime"
            v-model="openStartTime"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="startTime"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :disabled="startDate == null"
          >
            <template v-slot:activator="{ on }">
              <input
                type="text"
                class="form-control browser-default"
                :placeholder="$t('Start Time')"
                readonly
                v-model="startTime"
                v-on="on"
                :disabled="startDate == null"
              />
            </template>
            <v-time-picker
              v-if="openStartTime"
              @change="onChangeDatetime"
              v-model="startTime"
              full-width
              @click:minute="$refs.startTime.save(startTime)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex xs1>
          <v-btn
            fab
            flat
            small
            color="primary"
            style="height: 35px; width: 35px"
            @click="
              startDate = null
              startTime = null
            "
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs3 class="form-control" :class="{ 'has-error': errors.has('enddate') }">
          <v-menu
            ref="openEndDate"
            v-model="openEndDate"
            :close-on-content-click="false"
            full-width
            max-width="290px"
            color="primary"
          >
            <template v-slot:activator="{ on }">
              <input
                type="text"
                class="form-control browser-default"
                :placeholder="$t('End Date')"
                readonly
                v-model="endDate"
                v-on="on"
                clearable
              />
            </template>
            <v-date-picker
              color="primary"
              @change="onChangeDatetime"
              v-model="endDate"
              @input="openEndDate = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs2 class="pl-1">
          <v-menu
            ref="endtime"
            v-model="openEndTime"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="endTime"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :disabled="endDate == null"
          >
            <template v-slot:activator="{ on }">
              <input
                type="text"
                class="form-control browser-default"
                :placeholder="$t('End Time')"
                readonly
                v-model="endTime"
                v-on="on"
                :disabled="endDate == null"
              />
            </template>
            <v-time-picker
              v-if="openEndTime"
              v-model="endTime"
              @change="onChangeDatetime"
              full-width
              @click:minute="$refs.endtime.save(endTime)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex xs1>
          <v-btn
            fab
            flat
            small
            color="primary"
            style="height: 35px; width: 35px"
            @click="
              endDate = null
              endTime = null
            "
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
    <div>
      <div class="mb-2">ระยะเวลาส่งผลวิ่ง</div>
      <v-layout wrap class="form-control">
        <v-flex xs3 class="form-control" :class="{ 'has-error': errors.has('startdate') }">
          <v-menu
            ref="sendopenStartDate"
            v-model="sendopenStartDate"
            :close-on-content-click="false"
            full-width
            max-width="290px"
            color="primary"
          >
            <template v-slot:activator="{ on }">
              <input
                type="text"
                class="form-control browser-default"
                :placeholder="$t('Start Date')"
                readonly
                v-model="sendstartDate"
                v-on="on"
                clearable
              />
            </template>
            <v-date-picker
              @change="onChangeDatetime"
              color="primary"
              v-model="sendstartDate"
              @input="sendopenStartDate = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs2 class="pl-1">
          <v-menu
            ref="sendopenStartTime"
            v-model="sendopenStartTime"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="sendstartTime"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :disabled="sendstartDate == null"
          >
            <template v-slot:activator="{ on }">
              <input
                type="text"
                class="form-control browser-default"
                :placeholder="$t('Start Time')"
                readonly
                v-model="sendstartTime"
                v-on="on"
                :disabled="sendstartDate == null"
              />
            </template>
            <v-time-picker
              v-if="sendopenStartTime"
              v-model="sendstartTime"
              @change="onChangeDatetime"
              full-width
              @click:minute="$refs.sendopenStartTime.save(sendstartTime)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex xs1>
          <v-btn
            fab
            flat
            small
            color="primary"
            style="height: 35px; width: 35px"
            @click="
              sendstartDate = null
              sendstartTime = null
            "
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs3 class="form-control" :class="{ 'has-error': errors.has('enddate') }">
          <v-menu
            ref="sendopenEndDate"
            v-model="sendopenEndDate"
            :close-on-content-click="false"
            full-width
            max-width="290px"
            color="primary"
          >
            <template v-slot:activator="{ on }">
              <input
                type="text"
                class="form-control browser-default"
                :placeholder="$t('End Date')"
                readonly
                v-model="sendendDate"
                v-on="on"
                clearable
              />
            </template>
            <v-date-picker
              color="primary"
              @change="onChangeDatetime"
              v-model="sendendDate"
              @input="sendopenEndDate = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs2 class="pl-1">
          <v-menu
            ref="sendopenEndTime"
            v-model="sendopenEndTime"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="sendendTime"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :disabled="sendendDate == null"
          >
            <template v-slot:activator="{ on }">
              <input
                type="text"
                class="form-control browser-default"
                :placeholder="$t('End Time')"
                readonly
                v-model="sendendTime"
                v-on="on"
                :disabled="sendendDate == null"
              />
            </template>
            <v-time-picker
              @change="onChangeDatetime"
              v-if="sendopenEndTime"
              v-model="sendendTime"
              full-width
              @click:minute="$refs.sendopenEndTime.save(sendendTime)"
            ></v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex xs1>
          <v-btn
            fab
            flat
            small
            color="primary"
            style="height: 35px; width: 35px"
            @click="
              sendendDate = null
              sendendTime = null
            "
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: ['value', 'type', 'product'],
  data() {
    return {
      openStartDate: false,
      startDate: null,
      openStartTime: false,
      startTime: null,
      openEndDate: false,
      endDate: null,
      openEndTime: false,
      endTime: null,

      sendopenStartDate: false,
      sendstartDate: null,
      sendopenStartTime: false,
      sendstartTime: null,
      sendopenEndDate: false,
      sendendDate: null,
      sendopenEndTime: false,
      sendendTime: null
    }
  },
  mounted() {
    if (this.type == 'edit') {
      if (this.product.effectivedate) {
        this.startDate = moment(this.product.effectivedate).format('YYYY-MM-DD')
        this.startTime = moment(this.product.effectivedate).format('HH:mm')
      }
      if (this.product.enddate) {
        this.endDate = moment(this.product.enddate).format('YYYY-MM-DD')
        this.endTime = moment(this.product.enddate).format('HH:mm')
      }
      if (this.product.effectivedate2) {
        this.sendstartDate = moment(this.product.effectivedate2).format('YYYY-MM-DD')
        this.sendstartTime = moment(this.product.effectivedate2).format('HH:mm')
      }
      if (this.product.enddate2) {
        this.sendendDate = moment(this.product.enddate2).format('YYYY-MM-DD')
        this.sendendTime = moment(this.product.enddate2).format('HH:mm')
      }
    }
  },
  methods: {
    onChangeDatetime() {
      var data = {
        effectivedate: null,
        enddate: null,
        effectivedate2: null,
        enddate2: null
      }

      if (this.startDate) {
        Object.assign(data, {
          effectivedate:
            moment(this.startDate).format('YYYY-MM-DD') +
            ' ' +
            (this.startTime ? this.startTime : '00:00') +
            ':00+07'
        })
      }
      if (this.endDate) {
        Object.assign(data, {
          enddate:
            moment(this.endDate).format('YYYY-MM-DD') +
            ' ' +
            (this.endTime ? this.endTime : '00:00') +
            ':00+07'
        })
      }
      if (this.sendstartDate) {
        Object.assign(data, {
          effectivedate2:
            moment(this.sendstartDate).format('YYYY-MM-DD') +
            ' ' +
            (this.sendstartTime ? this.sendstartTime : '00:00') +
            ':00+07'
        })
      }
      if (this.sendendDate) {
        Object.assign(data, {
          enddate2:
            moment(this.sendendDate).format('YYYY-MM-DD') +
            ' ' +
            (this.sendendTime ? this.sendendTime : '00:00') +
            ':00+07'
        })
      }
      this.$emit('input', data)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/RunkanDatetime.vue